import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { completeConsultationReport } from "~/providers/api";
import { PatientConsultationReportData } from "~/providers/utils/types/consultation";

export const useCompleteConsultationReport = (consultationId?: string) => {
  const queryClient = useQueryClient();
  const { mutate: completeConsultationReportMutation, isPending } = useMutation(
    {
      mutationFn: (consultationReportData: PatientConsultationReportData) =>
        completeConsultationReport(consultationReportData, consultationId),
      onError: () =>
        toast.error(
          "We shoot trouble completing the consultation report, if the issue persists please reload the page!",
        ),
      onSuccess: async () => {
        toast.success("Consultation report completed successfully!");
        await queryClient.invalidateQueries({
          queryKey: ["getConsultationReport", consultationId],
        });
      },
    },
  );

  return { completeConsultationReportMutation, isPending };
};
